import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

// Assets
const QuestionSVG = require('../../assets/illustrations/question.svg') as string;

// Services
import { homeList, IHomeListResponse } from '../../services/network';
import {
  IOption,
  getQuestionComments,
  IGetQuestionsCommentResponse,
  createQuestionComments
} from '../../services/question';

// Types
import { IStore } from '../../store/Store';
export type INotificationAll = IHomeListResponse;
export type INotificationOption = IOption;
export type IComment = IGetQuestionsCommentResponse;

// Components
import Box from '../../components/Box';
import CommentsDialog from '../../components/CommentsDialog';
import { CircularProgress } from '../../components/Progress';
import StatusCard from '../../components/StatusCard';

import NotificationListItem from './NotificationListItem';
import QuestionDialog from '../AppNetworkQuestions/QuestionDialog'; // TODO: hotfix

// Component
interface IProps {
  store?: IStore;
}

class NotificationList extends React.Component<IProps> {
  @observable
  questionDialogState: {
    open: boolean;
    questionId: string | null;
    networkId: string | null;
  } = {
    open: false,
    questionId: null,
    networkId: null
  };

  @observable
  commentDialogState: {
    open: boolean;
    questionId: string | null;
    networkId: string | null;
  } = {
    open: false,
    questionId: null,
    networkId: null
  };
  @observable.shallow notificationsAll: INotificationAll[] | null = null;
  @observable comments: IComment[] | null = null;

  componentDidMount() {
    this.getNotifications();
  }

  async getComments() {
    this.comments = await getQuestionComments({
      params: {
        networkId: this.commentDialogState.networkId!
      },
      query: {
        questionId: this.commentDialogState.questionId!
      }
    });
  }

  async createComment(comment: string) {
    await createQuestionComments({
      params: {
        networkId: this.commentDialogState.networkId!
      },
      query: {
        questionId: this.commentDialogState.questionId!
      },
      body: {
        comment: comment
      }
    });

    this.getComments();
  }

  getNotifications = async () => {
    const networkId = this.props.store!.networkStore.network!.networkId;
    this.notificationsAll = await homeList({ params: { networkId } });
  };

  handleQuestionDelete = async () => {
    this.getNotifications();
    this.handleQuestionDialogClose();
  };

  @action
  handleRequestComment = (questionId: string, networkId: string) => () => {
    this.commentDialogState.open = true;
    this.commentDialogState.questionId = questionId;
    this.commentDialogState.networkId = networkId;
    this.getComments();
  };

  handleCommentDialogSubmit = async (comment: string) => {
    await this.createComment(comment);
  };

  handleCommentDialogClose = () => {
    this.commentDialogState.open = false;
  };

  @action
  handleCommentDialogExited = () => {
    this.commentDialogState.open = false;
    this.commentDialogState.questionId = null;
    this.commentDialogState.networkId = null;
    this.comments = null;
  };

  @action
  handleRequestQuestion = (questionId: string, networkId: string) => () => {
    this.questionDialogState.open = true;
    this.questionDialogState.questionId = questionId;
    this.questionDialogState.networkId = networkId;
  };

  @action
  handleQuestionDialogClose = () => {
    this.questionDialogState.open = false;
    this.questionDialogState.questionId = null;
    this.questionDialogState.networkId = null;
    this.comments = null;
  };

  render() {
    if (this.notificationsAll === null) {
      return (
        <Box pa={5} align="center">
          <CircularProgress />
        </Box>
      );
    }

    const role = this.props.store!.networkStore.person!.role;

    return (
      <div>
        {this.notificationsAll.length > 0 ? (
          this.notificationsAll.map(item => (
            <div key={item.questionId}>
              <NotificationListItem
                question={item}
                onRequestQuestion={this.handleRequestQuestion(
                  item.questionId,
                  item.networkId
                )}
                onRequestComment={this.handleRequestComment(
                  item.questionId,
                  item.networkId
                )}
              />
            </div>
          ))
        ) : (
          <StatusCard
            icon={QuestionSVG}
            headline={'No questions'}
            subheading={'There has not been asked any questions yet.'}
          />
        )}
        <QuestionDialog
          state={this.questionDialogState}
          onClose={this.handleQuestionDialogClose}
          onDeleted={this.handleQuestionDelete}
          userRole={role}
        />
        <CommentsDialog
          comments={this.comments}
          state={this.commentDialogState}
          onSubmit={this.handleCommentDialogSubmit}
          onClose={this.handleCommentDialogClose}
          onExited={this.handleCommentDialogExited}
        />
      </div>
    );
  }
}

export default inject('store')(observer(NotificationList));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkHome/NotificationList.tsx